// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vfyn","label":"styles_label__j6I_q"};